// import Vue from 'vue/dist/vue';
import { createI18n } from 'vue-i18n'

// Vue.use(VueI18n)

// Ukrainian and Polish pick a form English has no use for: 1 пересадка,
// 2 пересадки, 5 пересадок. The teens all take the last form.
function slavicPlural(choice) {
  const withinHundred = Math.abs(choice) % 100
  const lastDigit = withinHundred % 10

  if (withinHundred > 10 && withinHundred < 20) return 2
  if (lastDigit === 1) return 0
  if (lastDigit > 1 && lastDigit < 5) return 1

  return 2
}

const pluralRules = { ua: slavicPlural, pl: slavicPlural }

export const i18n = (messages) => {
  return createI18n({
    locale: getDefaultLang(),
    fallbackLocale: 'en',
    messages,
    pluralRules
  })
}

function getDefaultLang(){
  let locale = 'en'
  if (lsAvailable() && localStorage.getItem("drct-lang") !== null){
    locale = localStorage.getItem("drct-lang")
  }
  return locale
}

function lsAvailable(){
    const test = 'test';
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch(e) {
        return false;
    }
}
